import { CommonText } from "components/common/text/text.component";
import { PendingGridColumnsTypes } from "../Detail/device-detail.config";
import { DeviceColumnTypes, DeviceValueTypes } from "../devices.config";
import { StatusDotWrapper, GreenStatusDot } from "../Devices.style";
import React from "react";
import { PoolDeviceTypes } from "pages/Pools/pools.config";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { getDateString } from "utils/util-functions";

dayjs.extend(utc);

export const getTableCellValue = (
  column: DeviceColumnTypes | PendingGridColumnsTypes,
  value: any,
  row?: DeviceValueTypes | PoolDeviceTypes,
): any => {
  if (column.id === "online") {
    return <StatusDotWrapper>{value && <GreenStatusDot />}</StatusDotWrapper>;
  }

  if (column.id === "updateAvailable") {
    if (!value) {
      return <CommonText>No</CommonText>;
    }

    // Check for updateStatus if row data is available
    const updateStatus = row && "updateStatus" in row ? row.updateStatus : undefined;

    if (updateStatus) {
      if (updateStatus === "InProgress") {
        return (
          <div>
            <CommonText sx={{ color: "var(--mega-color-error)" }}>Yes</CommonText>
            <CommonText sx={{ color: "var(--mega-color-error)", fontSize: "12px", display: "block" }}>
              In Progress
            </CommonText>
          </div>
        );
      }

      if (updateStatus.startsWith("Scheduled")) {
        // Extract date from "Scheduled 2025-12-13 22:00:00" format
        const dateMatch = updateStatus.match(/(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})/);
        let scheduledDate = "";
        if (dateMatch) {
          // Parse UTC date string and convert to local time using the same method as Last Checkin
          const utcDateString = dateMatch[1];
          const localDateString = getDateString(dayjs.utc(utcDateString).local());
          scheduledDate = localDateString;
        }
        return (
          <div>
            <CommonText sx={{ color: "var(--mega-color-error)" }}>Yes</CommonText>
            <CommonText sx={{ color: "var(--mega-color-error)", fontSize: "12px", display: "block" }}>
              Scheduled{scheduledDate ? ` ${scheduledDate}` : ""}
            </CommonText>
          </div>
        );
      }

      if (updateStatus.includes("Pending")) {
        // On Devices page, show just "Pending", on detail page show full message
        const displayText = updateStatus === "Pending - Device is OFF" ? "Pending" : "Pending";
        return (
          <div>
            <CommonText sx={{ color: "var(--mega-color-error)" }}>Yes</CommonText>
            <CommonText sx={{ color: "var(--mega-color-error)", fontSize: "12px", display: "block" }}>
              {displayText}
            </CommonText>
          </div>
        );
      }
    }

    return <CommonText sx={{ color: "var(--mega-color-error)" }}>Yes</CommonText>;
  }

  if (column.id === "rxBytes" || column.id === "txBytes") {
    const megaByte: number = value / 1048576;

    return megaByte.toFixed(6);
  }

  if (column.format && typeof value === "number") {
    return column.format(value);
  }

  if (column.format) {
    return column.format(value);
  }

  return value;
};
